export default __webpack_public_path__ + "static/media/XEMP-27.0b5d3e49.jpg";